import { ShoppingBag } from "lucide-react";

import type { OnsiteUpsellComponent } from "@src/store/slices/experienceBuilder/types";
import { ModificationListItem } from "@src/features/experienceBuilder/modifications/common/ModificationListItem";

export const OnsiteUpsellComponentListItem = ({
  mod,
}: {
  mod: OnsiteUpsellComponent;
}) => {
  const subtitle =
    mod.description ||
    (mod.location === "cart" ? "Cart upsell" : "Product page upsell");
  return (
    <ModificationListItem
      mod={mod}
      icon={<ShoppingBag size={16} />}
      title="Onsite upsell"
      subtitle={subtitle}
    />
  );
};
